import connectQueryRules from "../connectors/connectQueryRules.js";
export default connectQueryRules(function QueryRuleContext() {
  return null;
}, {
  $$widgetType: 'ais.queryRuleContext'
});